import React, { useState, useRef, useContext, useEffect } from "react";
import { AuthContext } from "../../services/AuthContext";
import api, { setAuthToken, AuthAPI } from "../../api/api";
import "./LUserModal.css"

import { useAlert } from "../../services/AlertProvider";

export default function LUserModal() {
    const { isLoggedIn, login, logout, user, userModalOpen, setUserModalOpen } = useContext(AuthContext);
    const [activeTab, setActiveTab] = useState(isLoggedIn ? "Password" : "Login");
    const [activeSubTab, setActiveSubTab] = useState("Login");
    const [visible, setVisible] = useState(userModalOpen);
    const [email, setEmail] = useState("");
    const [displayName, setDisplayName] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [oldPassword, setOldPassword] = useState("");
    const [errors, setErrors] = useState({});
    const guideRef = useRef(null);

    const { showAlert } = useAlert();

    const changeActiveTab = (tab) => {
        setErrors({});
        setActiveTab(tab)
    }

    const changeActiveSubTab = (tab) => {
        setErrors({});
        setActiveSubTab(tab)
    }

    const InitialModal = () => {
        setErrors({});
        changeActiveSubTab("Login");
        setActiveTab(isLoggedIn ? "Account" : "Login");
        setVisible(true)
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                guideRef.current &&
                !guideRef.current.contains(event.target) &&
                visible
            ) {
                handleClose();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [visible]);

    useEffect(() => {
        if (userModalOpen) InitialModal();
        else {
            const timeout = setTimeout(() => {
                setEmail("");
                setDisplayName("");
                setPassword("");
                setConfirmPassword("");
                setOldPassword("");
                setVisible(false)
            }, 300);
            return () => clearTimeout(timeout);
        }
    }, [userModalOpen]);

    if (!visible) return null;

    const handleLogin = async (e) => {
        e.preventDefault();
        setErrors({});

        try {
            const res = await api.post("/auth/login", { email, password });
            const token = res.data.token;
            setAuthToken(token);
            login(token);
            handleClose();
        } catch (err) {
            if (err.response?.status === 400 && err.response.data) {
                Error400Show(err);
            } else if (err.response?.status === 401) {
                setErrors({ general: "Invalid email or password" });
            } else {
                setErrors({ general: "Server error" });
            }
        }
    };

    const handleForgotPass = async (e) => {
        e.preventDefault();
        setErrors({});

        try {
            const res = await api.post("/auth/forgot-password", { email });
            showAlert(res.data)
            handleClose();
        } catch (err) {
            if (err.response?.status === 404) {
                setErrors({ general: "Email not found." });
            } else {
                setErrors({ general: "Server error" });
            }
        }
    };

    const handleRegister = async (e) => {
        e.preventDefault();
        setErrors({});

        if (password === confirmPassword) {
            try {
                const res = await api.post("/users/register", { email, password, displayName });
                showAlert(res.data.message)
                handleClose();
            } catch (err) {
                if (err.response?.status === 400 && err.response.data) {
                    Error400Show(err);
                } else if (err.response?.status === 401) {
                    setErrors({ general: "Invalid email or password" });
                } else {
                    setErrors({ general: "Server error" });
                }
            }
        } else {
            return setErrors({ passConfirmation: "Password not match" })
        }
    };

    const handleChangePassword = async (e) => {
        e.preventDefault();
        setErrors({});

        if (password === confirmPassword) {
            const payload = {
                oldPassword: oldPassword,
                newPassword: password
            };

            try {
                const res = await AuthAPI.changePass(payload);
                showAlert(res.data)
                handleClose();
            } catch (err) {
                if (err.response?.status === 400 && err.response.data) {
                    Error400Show(err);
                } else if (err.response?.status === 401) {
                    setErrors({ general: "Invalid email or password" });
                } else {
                    setErrors({ general: "Server error" });
                }
            }
        } else {
            return setErrors({ passConfirmation: "Password not match" })
        }
    };

    const handleLogout = () => {
        logout();
        handleClose();
    };

    const handleClose = () => {
        setUserModalOpen(false);
    }

    const Error400Show = (err) => {
        const data = err.response?.data;
        if (typeof data === "object" && data.errors) {
            const message = Object.values(data.errors)
                .flat()
                .join(", ");
            showAlert(message);
        } else if (typeof data === "string") {
            showAlert(data);
        } else {
            showAlert("Bad request");
        }
    };

    const tabsView = () => {
        const tabs = isLoggedIn ? ["Account", "Password"] : ["Login", "Sign Up"];

        return (
            <div className="l-tabs">
                {tabs.map((tab, idx) => (
                    <div
                        key={tab}
                        className={`l-tab ${activeTab === tab ? "l-active" : ""} l-tab-${idx}`}
                        onClick={() => changeActiveTab(tab)}
                    >
                        {tab}
                    </div>
                ))}
            </div>
        );
    };

    const loginView = () => {
        return (
            <div key="login-form" className="l-login-form  l-fade-slide">
                {errors.general && <div className="l-errors"><p style={{ color: "red" }}>{errors.general}</p></div>}
                <div className="l-login-title">
                    <h1>Login</h1>
                </div>
                <form onSubmit={handleLogin}>
                    <input
                        name="email"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Email"
                        required />
                    {errors.Email && <p style={{ color: "red" }}>{errors.Email[0]}</p>}
                    <input
                        name="password"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Password"
                        required />
                    {errors.Password && <p style={{ color: "red" }}>{errors.Password[0]}</p>}
                    <button className="l-button" type="submit">Login</button>
                </form>
                <div className="l-login-buttons">
                    <button className="l-link-button" onClick={() => changeActiveSubTab("ForgotPass")}>
                        Forgot your password?
                    </button>
                    <div className="l-sign-up-link">
                        Don't have an account yet?
                        <button className="l-link-button" onClick={() => changeActiveTab("Sign Up")}>click here</button>
                    </div>
                </div>
            </div>
        );
    };

    const forgotPassView = () => {
        return (
            <div key="forgot-form" className="l-forgot-pass-form l-fade-slide">
                {errors.general && <div className="l-errors"><p style={{ color: "red" }}>{errors.general}</p></div>}
                <div className="l-forgot-pass-title">
                    <h1>Forgot Pass</h1>
                </div>
                <form onSubmit={handleForgotPass}>
                    <input
                        name="email"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Email"
                        required />
                    {errors.Email && <p style={{ color: "red" }}>{errors.Email[0]}</p>}
                    <button className="l-button" type="submit">Send</button>
                </form>
                <div className="l-forgot-buttons">
                    <button className="l-link-button" onClick={() => changeActiveSubTab("Login")}>
                        You Have Password?
                    </button>
                    <div className="l-sign-up-link">
                        Don't have an account yet?
                        <button className="l-link-button" onClick={() => changeActiveTab("Sign Up")}>click here</button>
                    </div>
                </div>
            </div>
        );
    };

    const signUpView = () => {
        return (
            <div key="sign-up-form" className="l-sign-up-form l-fade-slide">
                {errors.general && <div className="l-errors"><p style={{ color: "red" }}>{errors.general}</p></div>}
                {errors.passConfirmation && <div className="l-errors"><p style={{ color: "red" }}>{errors.passConfirmation}</p></div>}
                <div className="l-sign-up-title">
                    <h1>Sign Up</h1>
                </div>
                <form onSubmit={handleRegister}>
                    <input
                        name="displayName"
                        type="displayName"
                        value={displayName}
                        onChange={(e) => setDisplayName(e.target.value)}
                        placeholder="Name"
                        required />
                    <input
                        name="email"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Email"
                        required />
                    <input
                        name="password"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Password"
                        required />
                    <input
                        name="confirmPassword"
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        placeholder="Confirm Password"
                        required />
                    <button className="l-button" type="submit">Sign Up</button>
                </form>
                <div className="l-sign-up-buttons">
                    <div className="l-sign-up-link">
                        Already have an account?
                        <button className="l-link-button" onClick={() => changeActiveTab("Login")}>click here</button>
                    </div>
                </div>
            </div>
        );
    };

    const changePasswordView = () => {
        return (
            <div key="password-form" className="l-password-form l-fade-slide">
                {errors.general && <div className="l-errors"><p style={{ color: "red" }}>{errors.general}</p></div>}
                {errors.passConfirmation && <div className="l-errors"><p style={{ color: "red" }}>{errors.passConfirmation}</p></div>}
                <div className="l-password-title">
                    <h1>Change Pass</h1>
                </div>
                <form onSubmit={handleChangePassword}>
                    <input
                        name="oldPassword"
                        type="password"
                        value={oldPassword}
                        onChange={(e) => setOldPassword(e.target.value)}
                        placeholder="Old Password"
                        required />
                    <input
                        name="password"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="New Password"
                        required />
                    <input
                        name="confirmPassword"
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        placeholder="Confirm New Password"
                        required />
                    <button className="l-button" type="submit">Change</button>
                </form>
            </div>
        );
    };

    const accountView = () => {
        return (
            <>
                {user
                    ? <div key="account-form" className="l-account-form l-fade-slide">
                        <div className="l-account-title">
                            <h1>Account Info</h1>
                        </div>
                        <div className="l-account-content">
                            <div className="l-account-list">
                                <div className="l-account-label">Name:</div>
                                <div className="l-account-field">{user.displayName}</div>
                            </div>
                            <div className="l-account-list">
                                <div className="l-account-label">Email:</div>
                                <div className="l-account-field">{user.email}</div>
                            </div>
                            <div className="l-account-list">
                                <div className="l-account-label">Type:</div>
                                <div className="l-account-field">{user.role}</div>
                            </div>
                        </div>
                    </div>
                    : <div>Loading...</div>}

            </>

        );
    };

    return (
        <div className={`l-modal-backdrop ${userModalOpen ? "l-open" : "l-closed"}`}>
            <div ref={guideRef} className={`l-modal ${userModalOpen ? "l-open" : "l-closed"}`}>
                <button className="l-close-btn" onClick={handleClose}>×</button>
                {isLoggedIn && <button className="l-logout-btn" onClick={handleLogout}><i className="fas fa-sign-out-alt"></i></button>}
                <div className="l-modal-main">
                    <div className="l-modal-inner">
                        {tabsView()}
                        <div className="l-tab-content">
                            {activeTab === "Login" && (activeSubTab === "Login" ? loginView() : forgotPassView())}
                            {activeTab === "Sign Up" && signUpView()}
                            {activeTab === "Password" && changePasswordView()}
                            {activeTab === "Account" && accountView()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
